import Swal from "sweetalert2";
import $ from "jquery";
// Enregistre $.fn.DataTable sur CETTE instance de jQuery. Indispensable depuis
// le passage des routes en lazy loading : le plugin n'était jusqu'ici chargé
// que par effet de bord, via quelques pages de src/backoffice/acteurs/ que le
// bundle unique évaluait au démarrage. Avec les chunks séparés, une page qui
// n'importe pas ces fichiers appelait setDataTable() sans plugin enregistré.
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.css";
import StatutDossierEnum from "../enum/statutDossierEnum";
import AdministrationService from "../services/AdministrationService";
import JonctionsService from "../services/JonctionsService";
import sanitizeHtml from "sanitize-html";

import { createRoot } from "react-dom/client";
// Fonction pour afficher les messages d'erreur avec SweetAlert
export function afficherMessagesErreur(errors) {
  let messageErreur = "";

  if (!errors) {
    messageErreur = "Une erreur est survenue, veuillez réessayer.";
  } else if (typeof errors === "string") {
    // Cas : afficherMessagesErreur(error.response.data?.message)
    messageErreur = sanitizeHtml(errors, { allowedTags: [], allowedAttributes: {} });
  } else {
    // Cas : objet { status, message } ou { message, errors: {...} }
    const details =
      errors.errors && typeof errors.errors === "object" ? errors.errors : null;

    if (details) {
      messageErreur = Object.entries(details)
        .map(([key, value]) => {
          const text = Array.isArray(value) ? value.join("<br>") : String(value);
          return `${key}: ${text}`;
        })
        .join("<br>");
    } else if (errors.message) {
      messageErreur = String(errors.message);
    } else {
      // Ancien format : { champ: [messages] }
      messageErreur = Object.entries(errors)
        .map(([key, value]) => {
          const text = Array.isArray(value) ? value.join("<br>") : String(value);
          return `${key}: ${text}`;
        })
        .join("<br>");
    }
  }

  Swal.fire({
    icon: "error",
    title: "Erreur",
    html: messageErreur,
    toast: true,
    position: "top-end",
    timer: 10000,
    showConfirmButton: false,
    showCancelButton: true,
    cancelButtonText: "Fermer",
    timerProgressBar: true,
  });
}

export function afficherMessagesSuccess(message) {
  Swal.fire({
    icon: "success",
    title: message,
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    background: "green",
    color: "white",
    iconColor: "white",
  });
}

export function afficherOneMessageError(message) {
  Swal.fire({
    icon: "error",
    title: message,
  });
}

export function copyToClipboard(ref) {
  //var copyText = document.getElementById(elementId);

  navigator.clipboard.writeText(ref);
  // afficher alert copied
  afficherMessagesSuccess("Texte copié ! : " + ref);
}

export function convertDateToTexte(dateString) {
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  return new Date(dateString).toLocaleDateString("fr-FR", options);
}

//Formater la date en Mer. 18 Dec. 2024
export function convertDateToMinTexte(dateInput) {
  // Crée un tableau pour les jours abrégés
  const jours = ["Dim.", "Lun.", "Mar.", "Mer.", "Jeu.", "Ven.", "Sam."];

  // Crée un tableau pour les mois abrégés
  const mois = [
    "janv.",
    "févr.",
    "mars",
    "avr.",
    "mai",
    "juin",
    "juil.",
    "août",
    "sept.",
    "oct.",
    "nov.",
    "déc.",
  ];

  // Crée un objet Date à partir de l'entrée
  const date = new Date(dateInput);

  // Récupère les composants formatés
  const jour = jours[date.getDay()];
  const numeroJour = date.getDate();
  const moisAbrege = mois[date.getMonth()];
  const annee = date.getFullYear();

  // Retourne la chaîne formatée
  return `${jour} ${numeroJour} ${moisAbrege} ${annee}`;
}

export function getLastPartWithoutExtension(str) {
  // Trouver l'index de la dernière barre oblique "/"
  const lastSlashIndex = str.lastIndexOf("/");

  // Extraire la partie après la dernière barre oblique
  let lastPart = str.substring(lastSlashIndex + 1);

  // Supprimer l'extension ".pdf"
  lastPart = lastPart.replace(".pdf", "");

  return lastPart;
}

export function getPaiementConfig(code) {
  return {
    key:
      process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_KKIAPAY_PUBLIC_KEY
        : process.env.REACT_APP_KKIAPAY_SANDBOX_PUBLIC_KEY,
    isSandbox: process.env.NODE_ENV === "production" ? false : true,
  };
}

export function setDataTable() {
  // initialize datatable
  $(document).ready(function () {
    $(".data-table").DataTable({
      buttons: ["copy", "csv", "excel", "pdf", "print"],
      layout: {
        topStart: "buttons",
      },
      ordering: true,
      language: {
        sProcessing: "Traitement en cours ...",
        //sLengthMenu: "Afficher _MENU_ lignes",
        sZeroRecords: "Aucun résultat trouvé",
        sEmptyTable: "Aucune donnée disponible",
        sLengthMenu: "Afficher &nbsp; _MENU_ &nbsp;",
        sInfo: "_START_ ... _END_/_TOTAL_ &eacute;l&eacute;ments",
        sInfoEmpty: "Aucune ligne affichée",
        sInfoFiltered: "(Filtrer un maximum de _MAX_)",
        sInfoPostFix: "",
        sSearch: "Recherche",
        sUrl: "",
        sInfoThousands: ",",
        sLoadingRecords: "Chargement...",
        oPaginate: {
          sFirst: "Premier",
          sLast: "Dernier",
          sNext: "Suivant",
          sPrevious: "Précédent",
        },
        oAria: {
          sSortAscending: ": Trier par ordre croissant",
          sSortDescending: ": Trier par ordre décroissant",
        },
      },
      dom: '<"float-left"l><"float-right"f>Brti<"float-right"p>',
      //   stateSave : true,
      order: [[0, "asc"]],
      processing: true,
      serverSide: false,
      retrieve: true,
      //paging: false
      // ✅ Ignore les lignes de groupe
      rowCallback: function (row, data, index) {
        if ($(row).hasClass("dt-group-row")) {
          // Remove the 'data' to make DataTables ignore this row
          $(row).removeClass("odd even");
        }
      },
    });
  });
}


export function setGroupedDataTable() {
  $(document).ready(function () {
    $(".data-table-grouped").DataTable({
      buttons: ["copy", "csv", "excel", "pdf", "print"],
      layout: {
        topStart: "buttons",
      },
      ordering: true,
      order: [[3, "asc"]], // Ordre par mode de paiement
      rowGroup: {
        dataSrc: 3, // Index de la colonne "Mode de paiement" (0 = N°, 1 = prestation, ...)
      },
      language: {
        sProcessing: "Traitement en cours ...",
        sZeroRecords: "Aucun résultat trouvé",
        sEmptyTable: "Aucune donnée disponible",
        sLengthMenu: "Afficher &nbsp; _MENU_ &nbsp;",
        sInfo: "_START_ ... _END_/_TOTAL_ &eacute;l&eacute;ments",
        sInfoEmpty: "Aucune ligne affichée",
        sInfoFiltered: "(Filtrer un maximum de _MAX_)",
        sSearch: "Recherche",
        sLoadingRecords: "Chargement...",
        oPaginate: {
          sFirst: "Premier",
          sLast: "Dernier",
          sNext: "Suivant",
          sPrevious: "Précédent",
        },
        oAria: {
          sSortAscending: ": Trier par ordre croissant",
          sSortDescending: ": Trier par ordre décroissant",
        },
      },
      dom: '<"float-left"l><"float-right"f>Brti<"float-right"p>',
      processing: true,
      serverSide: false,
      retrieve: true,
    });
  });
}



export function filterStatut(liste_statuts) {
  const filteredData = liste_statuts.filter(
    (option) =>
      option.libelle == "ACTIF" ||
      option.libelle == "INACTIF" ||
      option.libelle == "BROUILLON"
  );

  return filteredData;
}
// Helper Pour permettre d'afficher le champ n° dossier

/*
PF_AVAUDAA = Procedure au fond : AVENIR D'AUDIENCE SUR ACTE D'APPEL

PP_AVAUDAA = Procedure présidentielle : AVENIR D'AUDIENCE SUR ACTE D'APPEL

*/

export function checkProcedureHelper(procedure_id, procedures) {
  if (procedure_id) {
    const checkFirstValue = procedures.find(
      (option) =>
        ((option.code == "PF_AVAUDAA" || option.code == "PP_AVAUDAA") || (option.code == "PP_AVAUDPC" || option.code == "PF_AVAUDPC") || (option.code == "PP_REMAUR" || option.code == "PF_REMAUR")) && option.id == procedure_id
    );
    const checkSecondValue = procedures.find(
      (option) =>
        option.code == "PF_AUTRES" &&
        option.id == procedure_id
    );


    if (checkFirstValue || checkSecondValue ) {
      return true;
    } else return false;
  }

  return false;
}

//Verifier s'il faut afficher toutes les dates disponibles
export function checkIsAvenirAudienceSurActeAppel(procedure_id, procedures) {
  if (procedure_id) {
    const checkFirstValue =  procedures.find(
      (option) =>
        (option.code == "PF_AVAUDAA" || option.code == "PP_AVAUDAA") &&
        option.id == procedure_id
    );

    if (checkFirstValue) {
      return true;
    }

    return false;

  }
}

export function checkIsAvenirAudienceSurProcedEnCours(procedure_id, procedures) {
  if (procedure_id) {
    const checkFirstValue =  procedures.find(
      (option) =>
        (option.code == "PF_AVAUDPC" || option.code == "PP_AVAUDPC")&&
        option.id == procedure_id
    );

    if (checkFirstValue) {
      return true;
    }

    return false;

  }
}

export function checkIsAutreProcedureHelper(procedure_id, procedures) {
  if (procedure_id) {
    const checkFirstValue = procedures.find(
      (option) =>
        option.code == "PF_AUTRES" &&
        option.id == procedure_id
    );

    //Verifie s'il s'agit de AUTRES PROCEDURES EN APPEL
    if (checkFirstValue) {
      //setIsAutreProcedure(true)
      return true;
    }
  }

  //setIsAutreProcedure(false)
  return false;
}

//Ordonner les dates par ordre croissant
export function sortedDates(dateString) {
  // Trier les dates par ordre croissant
  const sortedDates = dateString.sort((a, b) => {
    const dateA = new Date(a.jour);
    const dateB = new Date(b.jour);
    return dateA - dateB;
  });

  return sortedDates;
}

export function afficherErrorToast(message) {
  Swal.fire({
    icon: "error",
    title: message,
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    background: "red",
    color: "white",
    iconColor: "white",
  });
}

//fonction pour adapter les couleurs selon le statut du dossier
export function getColorStatus(status) {
  switch (true) {
    case StatutDossierEnum.isStatusNouveau(status):
      return "#378006";
    case StatutDossierEnum.isStatusRenvoye(status):
      return "#dc3545";
    case StatutDossierEnum.isStatusEnDelibere(status):
      return "#FF9800";
    case StatutDossierEnum.isStatusRadie(status):
      return "#7DCBC9";
    case StatutDossierEnum.isStatusVide(status):
      return "#5c636a";
    case StatutDossierEnum.isStatusJointure(status):
      return "#2b636a";
    default:
      return "#000000"; // Couleur par défaut si aucun statut ne correspond
  }
}

/**
 * Formatte un montant en fonction des options fournies.
 *
 * @param {number|string} amount - Le montant à formater.
 * @param {string} locale - La locale utilisée pour le formatage (ex : "fr-FR").
 * @param {string} currency - La devise à afficher (ex : "EUR", "USD", "XOF").
 * @returns {string} - Le montant formaté.
 */
export const formatAmount = (amount) => {
  if (isNaN(amount)) {
    console.warn("Le montant fourni n'est pas un nombre valide :", amount);
    return "Montant invalide";
  }

  const formatter = new Intl.NumberFormat( {
    style: "currency",
    minimumFractionDigits: 2, // Par défaut, deux décimales.
    maximumFractionDigits: 2, // Pour éviter trop de décimales.
  });

  return formatter.format(amount);
};

//Obtenir la date la plus récente
export const getLatestDate = (dates) => {
  if (!dates || dates.length === 0) return "N/A";

  // Filtrer uniquement les éléments avec statut_id == 1
  const validDates = dates
    .filter((item) => item.statut_id === 1 && item.get_calendrier?.jour) // Vérifie que la date existe
    .map((item) => new Date(item.get_calendrier.jour)); // Convertit en objet Date

  if (validDates.length === 0) return "N/A";

  // Trouve la date la plus récente
  const latestDate = validDates.reduce((max, date) => (date > max ? date : max), new Date(0));

  return convertDateToMinTexte(latestDate);
};


//Télécharger séparement les fichiers du système
export const downloadSingleFile = async (path, token) => {
  await AdministrationService.downloadFile({ filename: path }, token)
    .then((response) => {
      if (response.status == 200) {
        // Créez une URL pour le téléchargement du fichier
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;

        let name = path.split("/");

        // Ajoutez le nom du fichier à télécharger
        link.setAttribute("download", name[2] ?? "dossier.pdf");
        document.body.appendChild(link);
        link.click();

        // Nettoyez le DOM après l'utilisation
        link.parentNode.removeChild(link);

        afficherMessagesSuccess("Le fichier a été téléchargé avec succès.");
      } else {
        afficherMessagesErreur(response.data.message);
      }
    })
    .catch((error) => {
      console.log(error);
      afficherMessagesErreur(error.response.data?.message);
    });
};

export const findDossierFinal = async (dossier_id, token) => {
  await JonctionsService.index(token)
    .then((response) => {
      if (response.status == 200) {
        const dossier = response.data.data.find(
          (item) => item.dossier_source_id == dossier_id
        );
        return dossier ? dossier.reference_dossier : "";
      } else {
        afficherMessagesErreur(response.data.message);
      }
    })
    .catch((error) => {
      console.log(error);
      afficherMessagesErreur(error.response.data?.message);
    });
};

export const formatAmountWithoutCFA = (
  amount,
  locale = "fr-FR",
  currency = "XOF"
) => {
  if (isNaN(amount)) {
    console.warn("Le montant fourni n'est pas un nombre valide :", amount);
    return "Montant invalide";
  }

  const formatter = new Intl.NumberFormat(locale, {
    style: "decimal", // Utiliser le style "decimal" pour obtenir le formatage sans le symbole de la devise
    //currency: currency,
    //minimumFractionDigits: 0, // Par défaut, deux décimales.
    //maximumFractionDigits: 2, // Pour éviter trop de décimales.
  });

  // Formater le montant sans le symbole de la devise
  const formattedAmount = formatter.format(amount);

  // Ajouter manuellement le symbole "F" à la fin
  return `${formattedAmount} F`;
};

export const htmlFormater = (data) => {
  return (
    data &&
    sanitizeHtml(data, {
      allowedTags: [],
      allowedAttributes: {},
    })
  );
};

export const resoudreLienNotification = (lien, prefixeLien = "/admin") => {
  if (!lien) return null;
  if (lien.startsWith(prefixeLien)) return lien;

  // Espace des parties : la fiche d'un dossier est sur /dossiersacteurs/show/<ref>
  if (prefixeLien === "/parties") {
    return `${prefixeLien}${lien.replace(/^\/dossiers\/show\//, "/dossiersacteurs/show/")}`;
  }

  return `${prefixeLien}${lien}`;
};

// Fonction utilitaire pour charger le script TresorPay
export const loadTresorPayScript = () => {
  return new Promise((resolve, reject) => {
    // Vérifier si le script est déjà chargé
    if (
      document.querySelector(
        'script[src="https://cdn.tresorpay.bj/checkout.js?v=1.1.7"]'
      )
    ) {
      //console.log("Le script TresorPay est déjà chargé.");
      resolve();
      return;
    }

    // Créer et charger le script
    const script = document.createElement("script");
    script.src = "https://cdn.tresorpay.bj/checkout.js?v=1.1.7";
    script.async = true;
    script.onload = () => {
      //console.log("TresorPay script loaded");
      resolve(); // Script chargé avec succès
    };
    script.onerror = () => {
      console.error("Failed to load TresorPay script");
      reject(new Error("Failed to load TresorPay script"));
    };
    document.body.appendChild(script);
  });
};

/***
     * La clé SIR_CLASS prendra une des valeurs :
      - 1528 pour DEMANDE DE GROSSE -> 7.000
      - ⁠1527 pour DEMANDE DE COPIE D'ARRET -> 2.000
      - ⁠1526 pour ENROLEMENT DES AFFAIRES -> 10.000
      - 1542 pour ATTESTATION D'INSTANCE -> 2.000
      - 1541 pour ORDONNANCE SUR REQUETE -> 7.000
      - 1033 pour ATTESTATION DE RADIATION DE ROLE -> 2.000
***/

const mappings = {
  '7000-DEMANDE-ARRET': 1528,
  '2000-DEMANDE-ARRET': 1527,
  '10000-DOSSIER': 1526,
  '7000-REQUETE': 1541,
  '2000-ATTESTATION-INSTANCE': 1542,
  '2000-ATTESTATION-RADIATION': 1033,
};

export function getSirClass(montant_payer, type) {
  //console.log('type', type)
  //console.log('montant_payer', montant_payer)
  //console.log(mappings[`${montant_payer}-${type}`])
  return mappings[`${montant_payer}-${type}`] || 0;
}

